import { styled } from '@styledComponents';
import { Box } from '@components/Box';
import { Flex } from '@components/Flex';
import { TextPairing } from '@components/TextPairing';
import { themeMediaQuery, themeSpace } from '@utils/styledTheme.util';

const PAGE_MAX_WIDTH = '1200px';

export const StyledSection = styled(Box)`
  padding: ${themeSpace(10)} ${themeSpace(7)} ${themeSpace(8)};
  ${themeMediaQuery('md')} {
    padding: ${themeSpace(10)} ${themeSpace(12)} ${themeSpace(8)};
  }
  ${themeMediaQuery('lg')} {
    max-width: ${PAGE_MAX_WIDTH};
    padding: ${themeSpace(10)} 0 ${themeSpace(8)};
  }
`;

export const StyledFlex = styled(Flex)``;

export const StyledTextPairing = styled(TextPairing)`
  .text-pairing-title {
    margin-bottom: ${themeSpace(5)};
  }
`;

export const StyledGridContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  grid-gap: ${themeSpace(6)};
  ${themeMediaQuery('md')} {
    display: grid;
    grid-template-columns: 3fr 2fr;
  }
`;

export const StyledCardWrapper = styled(Box)`
  display: grid;
  grid-template-rows: 1fr 1fr 1fr;
  grid-gap: ${themeSpace(6)};
`;
